var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 27 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 38.1328H8.7825L8.5725 37.9303C9.3075 37.0753 9.75 35.9653 9.75 34.7578C9.75 32.0653 7.5675 29.8828 4.875 29.8828C2.1825 29.8828 0 32.0653 0 34.7578C0 37.4503 2.1825 39.6328 4.875 39.6328C6.0825 39.6328 7.1925 39.1903 8.0475 38.4553L8.25 38.6653V39.2578L12 43.0003L13.1175 41.8828L9.375 38.1328ZM4.875 38.1328C3.0075 38.1328 1.5 36.6253 1.5 34.7578C1.5 32.8903 3.0075 31.3828 4.875 31.3828C6.7425 31.3828 8.25 32.8903 8.25 34.7578C8.25 36.6253 6.7425 38.1328 4.875 38.1328Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2eb0584c43eac9efe7f21a5ecd9b39e9.svg";
export { ForwardRef as ReactComponent };